import React from 'react';
import { vmsService } from '../../../services/vmsService';

interface BankDetailsSectionProps {
  vendorBanks: any[];
  setVendorBanks: React.Dispatch<React.SetStateAction<any[]>>;
  initialDataId?: number;
}

export const BankDetailsSection: React.FC<BankDetailsSectionProps> = ({ vendorBanks, setVendorBanks, initialDataId }) => {
  return (
    <>
      <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '0.5rem', marginBottom: '1.5rem', marginTop: '2.5rem', color: 'var(--text-main)' }}>3. Bank Details</h3>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.5rem' }}>
        {vendorBanks.map((bank, idx) => (
          <div key={idx} className="form-row" style={{ alignItems: 'flex-start', border: '1px solid #eee', padding: '1rem', borderRadius: '8px', backgroundColor: '#fafafa', position: 'relative', flexWrap: 'wrap' }}>
            <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '1rem', alignItems: 'center', zIndex: 2 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', cursor: 'pointer', fontSize: '0.85rem', color: 'var(--text-main)', margin: 0 }}>
                <input 
                  type="radio" 
                  name="default_bank"
                  checked={bank.is_default}
                  onChange={() => {
                    const updated = vendorBanks.map((b, i) => ({...b, is_default: i === idx}));
                    setVendorBanks(updated);
                  }}
                  style={{ width: 'auto', margin: 0 }}
                />
                Default Bank
              </label>
              <button 
                type="button" 
                onClick={async () => {
                  if (bank.id && initialDataId) {
                    try {
                      await vmsService.archiveVendorBank(initialDataId, bank.id);
                    } catch (err) {
                      alert('Failed to archive bank');
                      return;
                    }
                  }
                  setVendorBanks(prev => prev.filter((_, i) => i !== idx));
                }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0', color: '#ef4444' }}
                title="Remove Bank"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                </svg>
              </button>
            </div>
            
            <div className="filter-group" style={{ flex: '1 1 45%' }}>
              <label>Bank Name *</label>
              <input type="text" value={bank.bank_name} onChange={e => {
                const updated = [...vendorBanks];
                updated[idx].bank_name = e.target.value;
                setVendorBanks(updated);
              }} required />
            </div>
            <div className="filter-group" style={{ flex: '1 1 45%' }}>
              <label>IFSC Code *</label>
              <input type="text" value={bank.ifsc_code} onChange={async e => {
                const ifsc = e.target.value.toUpperCase();
                const updated = [...vendorBanks];
                updated[idx].ifsc_code = ifsc;
                setVendorBanks(updated);
                
                if (ifsc.length === 11) {
                  try {
                    const res = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
                    if (res.ok) {
                      const data = await res.json();
                      const newBanks = [...vendorBanks];
                      newBanks[idx].bank_name = data.BANK || newBanks[idx].bank_name;
                      newBanks[idx].branch_address = data.ADDRESS || newBanks[idx].branch_address;
                      setVendorBanks(newBanks);
                    }
                  } catch (err) {}
                }
              }} required />
            </div>
            <div className="filter-group" style={{ flex: '1 1 45%' }}>
              <label>Account Number *</label>
              <input type="text" value={bank.account_number} onChange={e => {
                const updated = [...vendorBanks];
                updated[idx].account_number = e.target.value;
                setVendorBanks(updated);
              }} required />
            </div>
            <div className="filter-group" style={{ flex: '1 1 100%' }}>
              <label>Branch Address *</label>
              <input type="text" value={bank.branch_address} onChange={e => {
                const updated = [...vendorBanks];
                updated[idx].branch_address = e.target.value;
                setVendorBanks(updated);
              }} required />
            </div>
          </div>
        ))}

        <button 
          type="button" 
          className="secondary-btn" 
          onClick={() => {
            setVendorBanks(prev => [
              ...prev, 
              { bank_name: '', account_number: '', ifsc_code: '', branch_address: '', is_default: prev.length === 0 }
            ]);
          }}
          style={{ alignSelf: 'flex-start' }}
        >
          + Add Bank Account
        </button>
      </div>
    </>
  );
};
